import { render, staticRenderFns } from "./ScormDisplayNode.vue?vue&type=template&id=70a23ad3&"
import script from "./ScormDisplayNode.vue?vue&type=script&lang=js&"
export * from "./ScormDisplayNode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports